import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import PillsDataset from './PillsDataset'
import SelectDatasetModal from './modals/SelectDatasetModal'
import { FaPlus } from 'react-icons/fa'

interface Props {
  readOnly?: boolean
  selectedSources: string[]
  onSourcesChange: (sources: string[]) => void
}

const SelectedTrainingSourceCard: React.FC<Props> = ({
  readOnly = false,
  selectedSources,
  onSourcesChange,
}) => {
  const [showModal, setShowModal] = useState(false)

  const handleClose = () => setShowModal(false)

  const handleAcceptSelections = (sources: string[]) => {
    onSourcesChange(sources)
    setShowModal(false)
  }

  const handleRemoveDataset = (datasetName: string) => {
    if (readOnly) return
    const updatedSources = selectedSources.filter((source) => source !== datasetName)
    onSourcesChange(updatedSources)
  }

  if (!selectedSources?.length) {
    return (
      <>
        <Button
          variant="outline-light"
          onClick={() => !readOnly && setShowModal(true)}
          className="select-dataset-btn"
          style={{
            borderStyle: 'dashed',
            borderWidth: '2px',
            borderColor: '#3498db',
            backgroundColor: 'transparent',
            width: '100%',
            height: '60px',
            cursor: readOnly ? 'default' : 'pointer',
            opacity: readOnly ? 0.7 : 1,
          }}
          disabled={readOnly}
        >
          <FaPlus className="me-2" />
          Training Dataset
        </Button>
        <SelectDatasetModal
          canCreate={false}
          singleSelect={false}
          handleAcceptSelections={handleAcceptSelections}
          show={showModal}
          onHide={handleClose}
          selectedSources={selectedSources}
          updateGlobalState={false}
        />
      </>
    )
  }

  return (
    <>
      <div className="d-flex flex-column">
        <h6 className="text-white mb-0 mb-2">Training Source</h6>
        <div className="d-flex justify-content-between align-items-end gap-2">
          <div className="flex-grow-1">
            <PillsDataset
              datasetNames={selectedSources}
              disabled={readOnly}
              tiny={false}
              onToggleDataset={handleRemoveDataset}
            />
          </div>
          {!readOnly && (
            <Button
              variant="outline-light"
              size="sm"
              onClick={() => setShowModal(true)}
              style={{ minWidth: 'auto', padding: '0.25rem 0.5rem' }}
            >
              <FaPlus size={14} />
            </Button>
          )}
        </div>
      </div>
      <SelectDatasetModal
        canCreate={false}
        singleSelect={false}
        handleAcceptSelections={handleAcceptSelections}
        show={showModal}
        onHide={handleClose}
        selectedSources={selectedSources}
        updateGlobalState={false}
      />
    </>
  )
}

export default SelectedTrainingSourceCard
